import 'dayjs/locale/th'
import dayjs from 'dayjs'
import { styled, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { useRecordContext, useReference } from 'react-admin'
import { ModifyTimeStampProps, TimeStampProps } from './type'

const TimeTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
  textAlign: 'right',
}))

const StyledSpan = styled('span')({
  fontSize: 'inherit',
  fontWeight: 600,
})

const WORD_SET = {
  th: {
    createdBy: 'สร้างโดย',
    updatedBy: 'แก้ไขโดย',
    on: 'เมื่อ',
    date: (date: string): string =>
      dayjs(date).add(543, 'year').locale('th').format('DD MMMM YYYY, HH:mm'),
  },
  en: {
    createdBy: 'Created by',
    updatedBy: 'Updated by',
    on: 'on',
    date: (date: string): string => dayjs(date).format('DD MMMM YYYY, HH:mm'),
  },
}

const TimeStamp: React.FC<TimeStampProps> = ({
  autherID,
  reference,
  language,
  children,
  title,
}) => {
  const { referenceRecord: record, isLoading: isLoading } = useReference({
    reference,
    id: autherID,
  })

  const activeWordSet = WORD_SET[language]
  return (
    <>
      {!isLoading && autherID && (
        <TimeTypography variant='body2'>
          <StyledSpan>{title} </StyledSpan>
          {record.firstname_th} <StyledSpan>{activeWordSet.on} </StyledSpan>
          {children}
        </TimeTypography>
      )}
    </>
  )
}
const ModifyTimeStamp: React.FC<ModifyTimeStampProps> = ({
  language = 'th',
  create = true,
  update = true,
  reference = 'admins',
}: ModifyTimeStampProps) => {
  const record = useRecordContext()
  if (!record) {
    return null
  }
  const activeWordSet = WORD_SET[language]

  return (
    <Box>
      {/* Last Updated Time Stamp */}
      {update && (
        <TimeStamp
          reference={reference}
          language={language}
          title={activeWordSet.updatedBy}
          autherID={record.update_by}
        >
          {activeWordSet.date(record.update_at)}
        </TimeStamp>
      )}
      {/* Creation Time Stamp */}
      {create && (
        <TimeStamp
          reference={reference}
          language={language}
          title={activeWordSet.createdBy}
          autherID={record.create_by}
        >
          {activeWordSet.date(record.create_at)}
        </TimeStamp>
      )}
    </Box>
  )
}

export default ModifyTimeStamp
